import { request } from './request';

// 删除预检 + 级联勾选 (2026-08-21 硬删语义配套, 对应后端 changereq/preview.go).
// 删除前 GET <资源>/delete-preview 拿关联数据分组, 用户勾选的组 key 进 DELETE 请求体
// cascade; related 是预检快照原样回传, 只用于审批工单展示影响面.

export interface RelatedGroup {
    /** cascade 勾选键 */
    key: string;
    label: string;
    count: number;
    /** true = 纯从属数据必随主体删除, 勾选不可取消 */
    required?: boolean;
    /** 未勾选时的处理说明 (required=false 时有意义) */
    uncheckedNote?: string;
    /** 勾选时的确定结论 (组内各条后果不同时后端给出精确结果; 空 = 回退通用文案) */
    checkedNote?: string;
    /** 该组删除范围的补充说明 (无条件展示; 关系类组据此说明"只断关系, 对端实体不动") */
    note?: string;
    /** 阻塞项 (2026-09-08): 该组有数据时主体不允许删, 弹窗红色展示并禁用确认; note 写怎么解除 */
    blocking?: boolean;
    /** 逐条明细 (可选): 每条关联数据处理后果不同的组 (如多对多 SKU) 按行展示 */
    items?: string[];
}

export interface DeleteCascadePayload {
    cascade: string[];
    related?: RelatedGroup[];
}

/** 拉删除预检分组 (材料/设备等资源的 delete-preview 端点响应同构). */
export function fetchDeletePreview(url: string, body?: unknown): Promise<RelatedGroup[]> {
    // 2026-08-24: 预检也改 POST + 键走 body (与删除接口同一约定, 键含 "/" 才不会 404).
    return request<{ groups: RelatedGroup[] }>(url, { method: 'POST', dedupe: true, body }).then(
        (res) => res.groups || [],
    );
}
